import { render } from "./instructor-quiz-results.vue?vue&type=template&id=97d364aa"
import script from "./instructor-quiz-results.vue?vue&type=script&lang=js"
export * from "./instructor-quiz-results.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__